import React, { useEffect, useState } from 'react';
import LocationHero from './LocationHero';
import LocationBio from './LocationBio';
import LocationProviders from './LocationProviders';
import LocationActionWidget from './LocationActionWidget';
import ActionBar from '../shared/ActionBar';
import LocationWidget from './LocationWidget';
import LocationHours from './LocationHours';
import ProfileBreadcrumb from '../shared/ProfileBreadcrumb';
import Sidebar from '../shared/Sidebar';
import { LocationFields } from 'components/types/LocationTypes';
import getOsfViewportSize from 'assets/utils/getOsfViewportSize';
import Insurance from '../shared/Insurance';

type LocationProfileProps = {
	rendering: {
		fields: LocationFields;
	};
};

const LocationProfile = (props: LocationProfileProps): JSX.Element => {
	const [size, setSize] = useState('sm');
	const { rendering } = props;
	const fields = rendering.fields;

	useEffect(() => {
		const resize = () => {
			const viewportSize = getOsfViewportSize();
			setSize(viewportSize);
		};
		resize();
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	return (
		<div className="location-profile">
			<LocationHero img={fields.LocationImage} />
			<div className="overhauled">
				<div className="jss-inner-container">
					<div className="profile-layout">
						<div className="left-col">
							<ProfileBreadcrumb name="breadcrumb" />
							<LocationBio
								About={fields.About}
								LocationName={fields.LocationName}
								LocationTypes={fields.LocationTypes}
								ServicesOffered={fields.ServicesOffered}
							/>

							<Insurance />
							<LocationActionWidget
								mammogram={fields?.BookOnlineOverrideUrl?.value}
								pharmacy={fields?.LocationName?.value?.toLocaleLowerCase().includes('pharmacy')}
								urgent={fields?.LocationName?.value?.includes('OnCall Urgent')}
								prompt={fields?.LocationName?.value?.includes('PromptCare')}
								deptId={fields?.EpicDeptId?.value}
								providerId={fields?.EpicProviderId?.value}
								locationName={fields?.LocationName?.value}
								street1={fields?.Street1?.value}
								suite={fields?.Suite?.value}
								city={fields?.City?.value}
								state={fields?.State?.value}
								zip={fields?.Zip?.value}
								phone={fields?.Phone?.value}
							/>
							{(size == 'xs' || size == 'sm' || size == 'md') && (
								<LocationWidget
									img={fields.LocationImage}
									locationName={fields.LocationName?.value}
									street1={fields.Street1?.value}
									suite={fields.Suite?.value}
									city={fields.City?.value}
									state={fields.State?.value}
									zip={fields.Zip?.value}
									phone={fields.Phone?.value}
								/>
							)}
							{fields?.HoursOfOperation?.value && (
								<LocationHours hours={fields.HoursOfOperation.value} />
							)}
							{fields?.Providers?.HasProviders && fields?.Providers?.SpecialtyGroups && (
								<>
									<LocationProviders
										providers={fields.Providers}
										allProviders={fields?.AllProviders}
									/>
								</>
							)}
							<ActionBar print copy />
						</div>
						<div className="right-col">
							{(size == 'lg' || size == 'xl') && (
								<Sidebar header="Location" pageType="location" customHeader="osf-inner-h2">
									<LocationWidget
										img={fields.LocationImage}
										locationName={fields.LocationName?.value}
										street1={fields.Street1?.value}
										suite={fields.Suite?.value}
										city={fields.City?.value}
										state={fields.State?.value}
										zip={fields.Zip?.value}
										phone={fields.Phone?.value}
									/>
								</Sidebar>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LocationProfile;
